import { Component, Input, Output, EventEmitter, Inject, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserData, UserProfileModel } from "../../model/index"
import { SecurityService } from '../../Security/security.service';
import { HeaderService } from "./header.service";
declare var require: any;

@Component({
    selector: 'MentisSoft-Header',
    template: require('../Header/header.template.html'),
    styles: [require('../Header/header.css')],
    encapsulation: ViewEncapsulation.None
})

export class HeaderComponent implements AfterViewInit {
    headerText: string = 'MentisSoft';
    logoPath: string;
    UserProfile : UserProfileModel = new UserProfileModel();
    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private router: Router, private headerService: HeaderService, 
        private route: ActivatedRoute) {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
        if (router.url.toString() === '/Dashboard' ) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
            }
        }
        this.userData.User = localStorage.getItem("patientName");
    }
    userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid,  this._SecurityService.IsAdminUser);
    isClosed: boolean = false;
    IsAdminUser: boolean = false;
    IsFeedBack: boolean = true;
    AppointmentRequest: string="";
    LabRequest: string = "";
    RadiologyRequest: string = "";
    Hospital: string = "";

    ngAfterViewInit(): void {
        this.Hospital = localStorage.getItem("HospitalName");
        this.IsAdminUser = JSON.parse(localStorage.getItem("ISAdmin"));
        
        this.GetLoggedInUserImage();
    }
        
    hamburgercross() {
        if (this.isClosed == true) {
            $('#overlay').hide();
            $('#hamburger').removeClass('is-open');
            $('#hamburger').addClass('is-closed');
            $('#mainnav').removeClass('is-open');
            $('#mainnav').addClass('is-closed');

            this.isClosed = false;
        } else {
            $('#overlay').show();
            $('#hamburger').removeClass('is-closed');
            $('#hamburger').addClass('is-open');
            $('#mainnav').removeClass('is-closed');
            $('#mainnav').addClass('is-open');
            this.isClosed = true;
        }
    }

    LogchangePassword(event) {
        this.router.navigate(["/ChangePassword"]);
    }

    LogFeeddBack(event) {
        this.router.navigate(["/FeedBack"]);
    }
    LogPatientProfile(event) {
        this.router.navigate(["/PatientProfile"]);
    }
    LogSignOut(event) {
        this.headerService.UpdateSessionDetails()
            .subscribe(
            p => {
            });
        localStorage.clear();
        this.router.navigate(["/Login"]);
    }

    GetLoggedInUserImage() {
        this.headerService.GetLoggedInUserImage()
            .subscribe(
            p => {
                if (p != null && p.ValidUser && p.SessionTimeout != "Session Expired") {
                    this.UserProfile = p;
                    this.AppointmentRequest = p.AppointmentRequest;
                    this.LabRequest = p.LabRequest;
                    this.RadiologyRequest = p.RadiologyRequest;
                    localStorage.setItem("StoreAppointmentRequest", this.AppointmentRequest);
                    localStorage.setItem("StoreLabRequest", this.LabRequest);
                    localStorage.setItem("StoreRadiologyRequest", this.RadiologyRequest);
                    if (this.UserProfile.IsFeedBackAvailable == "FALSE")
                        this.IsFeedBack = false;
                    else
                        this.IsFeedBack = true;

                }
                else {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            });      
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/header/header.Component.ts